import { MEDIA_FRONTEND_URL } from '@src/configs';

const IMAGE_DIR = `${MEDIA_FRONTEND_URL}/images/events`;

// Used when the GrowthBook config leaves an image out.
export const DEFAULT_TOP_PAID_EVENT_IMAGES = {
  widgetBannerVi: `${IMAGE_DIR}/widget-banner-vi.webp`,
  widgetBannerEn: `${IMAGE_DIR}/widget-banner-en.webp`,
  mobileHeaderBannerVi: `${IMAGE_DIR}/apple-rewards-vi.webp`,
  mobileHeaderBannerEn: `${IMAGE_DIR}/apple-rewards-en.webp`,
  prizeIphone: `${IMAGE_DIR}/prize-iphone.webp`,
  prizeIpad: `${IMAGE_DIR}/prize-ipad.webp`,
  prizeAirpods: `${IMAGE_DIR}/prize-airpods.webp`,
  prizesTaglineDesktopVi: `${IMAGE_DIR}/prizes-tagline-desktop-vi.svg`,
  prizesTaglineMobileVi: `${IMAGE_DIR}/prizes-tagline-mobile-vi.svg`,
  prizesTaglineDesktopEn: `${IMAGE_DIR}/prizes-tagline-desktop-en.svg`,
  prizesTaglineMobileEn: `${IMAGE_DIR}/prizes-tagline-mobile-en.svg`,
  prizesTaglineArrow: `${IMAGE_DIR}/prizes-tagline-arrow.svg`,
};

// Opens the event page scrolled to the user's codes, e.g. from "View my codes".
export const TOP_PAID_EVENT_CODES_HASH = '#my-codes';

// A user places far fewer orders than this in one event, so one page holds them all.
export const EVENT_ORDERS_LIMIT = 1000;
